<template>
  <verify-password-input @result="verifyPassword" v-if="!verified"></verify-password-input>
  <div class="input-container" v-if="verified">
    <form @submit.prevent="submit">
      <input-text type="password" v-model="form.password" name="password" id="password" placeholder="新しいパスワードを入力"
        autocomplete="new-password" :error="getError(form, 'password')"></input-text>
      <input-text type="password" v-model="form.password_confirmation" name="password_confirmation" id="password_confirmation"
        placeholder="もう一度同じパスワードを入力" autocomplete="new-password" :error="getError(form, 'password_confirmation')"></input-text>
        <p class="notice danger-text bold">
          セキュリティ上、リセットを行うと過去に発行したQRコードが無効化されます。<br>
          リセットに伴い以前のパスワードとQRコードでログインしている端末ではログアウトされます。<br>
          再設定完了後、QRコードを再発行して対象者に渡してください。
        </p>
      <button type="submit" class="btn success" v-if="!isLoading">再設定する</button>
      <template v-if="isLoading">
        <loading :message="'再設定中...'"></loading>
      </template>
    </form>
  </div>
</template>

<script lang="ts">
import { UserApi } from "@/api/UserApi";
import Message from "@/const/Message";
import { DialogService } from "@/service/DialogService";
import { PasswordResetFromAdminReq, PasswordResetRes } from "@/types/User";
import { defineComponent, ref } from "vue";
import VerifyPassword from "@/components/auth/VerifyPassword.vue"
import { FormUtil } from "@/utils/FormUtil";
import { AxiosError } from "axios";
import { useForm } from "@/composable/form/form";

export default defineComponent({
  props: {
    form: {
      type: Object as () => PasswordResetFromAdminReq,
      default: () => ({ password: '', password_confirmation: '' })
    },
    userId: {
      type: Number,
      required: true
    }
  },
  setup(props) {
    const { getError } = useForm();
    let verified = ref(false);
    const isLoading = ref(false);
    props.form.userId = props.userId;

    const verifyPassword = (result: boolean) => {
      verified.value = result
    }

    const submit = async () => {
      isLoading.value = true;
      const api = new UserApi();
      let res: PasswordResetRes | null = null;
      // const req: PasswordResetFromAdminReq = {
      //   userId: props.userId,
      //   password: props.form.password,
      //   password_confirmation: props.form.password_confirmation
      // }
      try {
        res = await api.resetPasswordFromAdminn(props.form);
        if (!res.result) {
          DialogService.error({
            title: Message.ERROR_RESET_PASSWORD,
          })
          return
        }

        await DialogService.success({
          title: Message.SUCCESS_RESET_PASSWORD,
          text: 'パスワードを再設定しました。'
        })

        props.form.password = ''
        props.form.password_confirmation = ''
        verified.value = false
      } catch (error) {
        const err = error as AxiosError<any>;
        FormUtil.setLaravelError(props.form, err);
        console.log("");
      } finally {
        isLoading.value = false;
      }
    }

    return {
      getError,
      submit,
      isLoading,
      verified,
      verifyPassword
    };
  },
  components: {
    'verify-password-input': VerifyPassword
  },
});
</script>

<style lang="scss" scoped>
@import '@scss/pages/login.scss';
</style>
